<template>
	<div>
		<div class="msg_box">
			<div class="tech_title">学习资料</div>
			<div class="tech_select clearfloat">
				<div class="kuang search_long">
					<span class="el-icon-search"></span>
					<div class="searchInp">
						<el-input class="nav_search" v-model="searchVal" @change="tosearch"
					 select-when-unmatched placeholder="按货号/产品名/其他搜索"></el-input>
					</div>
				</div>
				<div class="select">
					<el-select  @change="Postmaterials();pageNo = 1;" class="chongsele" v-model="product_id" clearable placeholder="请选择产品">
						<el-option
						v-for="item in goodsList"
						:key="item.id"
						:label="item.model"
						:value="item.id" >
						<!-- :disabled="item.disabled" -->
						</el-option>
					</el-select>
				</div>
				<div class="select">
					<el-select @change="PostskillProduct" class="chongsele" v-model="category_id" clearable placeholder="请选择分类">
						<el-option
						v-for="item in classifyList"
						:key="item.id"
						:label="item.title"
						:value="item.id" >
						<!-- :disabled="item.disabled" -->
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="min_he400" v-loading="loading">
				<div class="datum clearfloat" v-for="item in materialsList" :key="item.id">
					<div class="dat_left">
						<div class="lit_btn laing_btn" @click="xin.goUrl('/oneDetails?cid='+item.category_id)">{{item.category_title}}</div>
					</div>
					<div class="dat_center">
						<div class="dat_title" @click="xin.goUrl('/products/'+item.id)">{{item.goods_title}}</div>
						<div class="dat_right" v-for="val in item.materials" :key="val.id">
							<div>{{val.subtitle}}</div>
							<div class="dat_btn li1" @click="xin.goNew(val.file)">{{val.title}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="bottom_paging">
				<el-pagination class="feye" :background="true" :current-page.sync="pageNo" :page-size="limit" layout="prev, pager, next, jumper"
				:total="total" @current-change="pageCurrentChange" :hide-on-single-page="true"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
	export default{
		data(){
			return {
				loading:true,
				searchVal:"",
				goodsList:[],//产品list
				title:'',//搜索值
				category_id:'',//分类id
				product_id:'',//产品id
				materialsList:[],//学习资料
				total:0,//总数量
				pageNo:1,//当前页
				limit:0,//一页多少条
			}
		},
		created(){
			this.Postmaterials();
		},
		computed: {
			...mapState(['classifyList']),
		},
		methods:{
			tosearch(e){//搜索
				e = e.replace(/\s+/g,"");
				this.title = e;
				this.Postmaterials();
			},
			async PostskillProduct(category_id){//根据分类获取产品
				this.product_id ='';
				this.pageNo = 1;
				this.Postmaterials();
				if(!category_id){
					this.goodsList = [];
					return;
				}
				let {data} = await this.api.PostskillProduct({category_id});
				this.goodsList = data;
			},
			async Postmaterials(){
				this.loading = true;
				let {pageNo,title,category_id,product_id} = this;
				let {data} = await this.api.Postmaterials({page:pageNo,title,category_id,product_id});
				this.materialsList = data.data;
				this.total = data.total;
				this.limit = data.per_page;
				this.loading = false;
			},
			pageCurrentChange(val) {//分页查询
				this.pageNo = val;
				this.Postmaterials();
			},
		}
	}
</script>

<style lang="scss" scoped>
	.chongsele{
	width: 100%;
	/deep/.el-input__inner{
		border-radius: 25px;
		height: 50px;
    	line-height: 50px;
	}
	/deep/.el-input__icon{
		line-height: 50px;
	}
}
.msg_box{
	.tech_select{
		.el-icon-search{
			
		}
		.searchInp{
			width: 230px;
		}
	}
}
.nav_search{
	/deep/.el-input__inner{
		border: none;
	}
}
</style>
